import React from 'react';
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";
import { Pencil, Trash2 } from "lucide-react";

const StockTable = ({
    items,
    loading = false,
    selectedItems = new Set(),
    toggleSelection,
    toggleSelectAll,
    onEdit,
    onDeleteRequest
}) => {
    const allSelected = items.length > 0 && items.every(item => selectedItems.has(item.stock_symbol));

    return (
        <div className="relative w-full overflow-auto rounded-md border">
            <table className="w-full caption-bottom text-sm">
                <thead className="[&_tr]:border-b bg-muted/50">
                    <tr>
                        <th className="h-12 px-4 text-left align-middle w-10">
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={toggleSelectAll}
                                className="h-4 w-4 rounded border-gray-300"
                            />
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">
                            Symbole
                        </th>
                        <th className="h-12 px-4 text-left align-middle font-medium text-muted-foreground">
                            Société
                        </th>
                        <th className="h-12 px-4 text-right align-middle font-medium text-muted-foreground">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody className="[&_tr:last-child]:border-0">
                    {loading ? (
                        Array.from({ length: 5 }).map((_, i) => (
                            <tr key={`skeleton-${i}`} className="border-b">
                                <td className="p-4 align-middle">
                                    <Skeleton className="h-4 w-4" />
                                </td>
                                <td className="p-4 align-middle">
                                    <Skeleton className="h-4 w-full" />
                                </td>
                                <td className="p-4 align-middle">
                                    <Skeleton className="h-4 w-full" />
                                </td>
                                <td className="p-4 align-middle">
                                    <Skeleton className="h-4 w-full" />
                                </td>
                            </tr>
                        ))
                    ) : items.length === 0 ? (
                        <tr>
                            <td colSpan="4" className="p-4 align-middle text-center text-muted-foreground">
                                Aucun stock
                            </td>
                        </tr>
                    ) : (
                        items.map((item) => (
                            <tr
                                key={item.stock_symbol}
                                className="border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted"
                                data-state={selectedItems.has(item.stock_symbol) ? "selected" : undefined}
                            >
                                <td className="p-4 align-middle">
                                    <input
                                        type="checkbox"
                                        checked={selectedItems.has(item.stock_symbol)}
                                        onChange={() => toggleSelection(item.stock_symbol)}
                                        className="h-4 w-4 rounded border-gray-300"
                                    />
                                </td>
                                <td className="p-4 align-middle font-semibold">
                                    {item.stock_symbol}
                                </td>
                                <td className="p-4 align-middle">
                                    {item.company_name}
                                </td>
                                <td className="p-4 align-middle text-right">
                                    <Button
                                        variant="outline"
                                        size="sm"
                                        onClick={() => onEdit(item)}
                                        className="mr-2"
                                    >
                                        <Pencil className="h-4 w-4 mr-1" />
                                        Modifier
                                    </Button>
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        className="text-destructive hover:text-destructive hover:bg-destructive/10"
                                        onClick={() => onDeleteRequest(item.stock_symbol)}
                                    >
                                        <Trash2 className="h-4 w-4 mr-1" />
                                        Supprimer
                                    </Button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default StockTable;
